export const DEFAULT_TASKLIST_HEADING = "Get started with Puzzle";
export const BREX_TASKLIST_HEADING = "Welcome from Brex!";
export const BOOKKEEPERS_TASKLIST_HEADING = DEFAULT_TASKLIST_HEADING;

export const DEFAULT_TASKLIST_DESCRIPTION =
  "Complete this guide to configure your account and discover essential workflows. Each step helps Puzzle get to work sooner for you. Have questions? Click below and our team will help.";
export const BOOKKEEPERS_TASKLIST_DESCRIPTION =
  "Get started on the right foot. Complete the following steps to ensure your account is configured to suit your needs. Need help? Book your set up call - we'd love to help you get started.";
export const BREX_TASKLIST_DESCRIPTION =
  "Welcome to Puzzle—the modern accounting platform for today’s operators and accountants. We automate the busywork so you can focus on running and growing your business. Complete the following steps to complete your setup and book your free onboarding call, we’d love to help you get started.";

export const BOOK_CALL_LABEL = "Book your setup call";

export const TASKLIST_BOTTOM_MARGIN = 12;
